import React, { Suspense } from 'react'
import { useFeatureFlags } from '@node-space/hooks'
import { RowsSkeletonLoader } from '@node-space/ui-components'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { Destinations } from 'pages/ManageIntegrations/components/Destinations'
import { createMFELazy } from 'utils/createMFELazy'

const WebhooksLazy = createMFELazy(() => import('webhooks/Webhooks'), {
  mfeName: 'Webhooks',
  testId: 'webhooks-mfe-error',
})

export const WebhooksPage = () => {
  const { enableWebhooksBff } = useFeatureFlags()

  if (!enableWebhooksBff) {
    return <Destinations />
  }

  return (
    <Suspense fallback={<RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}>
      <WebhooksLazy bffUrl={process.env.VITE_BASE_URL} />
    </Suspense>
  )
}
